import React, { useState, useEffect } from "react";
import { addDays, parseISO, formatISO } from "date-fns";
import YouTube from "react-youtube";

import useStateWithLocalstorage from "./hooks/useStateWithLocalstorage";
import useFirebaseUserDoc from "./hooks/useFirebaseUserDoc";

import AuthHeader from "./components/AuthHeader";
import Episodes from "./components/Episodes";

export default ({ user, signOut, signInWithGoogle, error, loading, db }) => {
  const userDoc = useFirebaseUserDoc({ user, db });

  return (
    <div className="my-16 mx-4 md:mx-auto md:w-1/2 xl:w-1/3">
      <AuthHeader {...{ user, signOut, signInWithGoogle }} />

      {!user && <YouTube videoId="yiK431ns93o" />}

      {user && userDoc && <Episodes db={db} userDoc={userDoc} user={user} />}
    </div>
  );
};
